/**
 * Проверяем поддерживает ли браузер service worker
 */
export const isServiceWorkerSupported = () =>
  'serviceWorker' in window.navigator
